import { ModalActions } from '@ui-kit/components/Modal/Modal';
import { useTranslation } from 'react-i18next';
import { AnchorButton } from '@/components/buttons';
import type { ModalProps } from '@/components/ModalRenderer/components/types';
import { Modal } from '@/components/ModalRenderer/Modal';
import { getConfig } from '@/constants/config';
import Button from '@/ui-kit/components/Button/Button';

const WithdrawalIpAddressCheck = ({ closeModal }: ModalProps) => {
  const { t } = useTranslation(['Modal', 'Common', 'Button']);

  return (
    <Modal title={t('WithdrawalIpAddressCheck.title')}>
      <p>{t('WithdrawalIpAddressCheck.info')}</p>
      <ModalActions>
        <Button onClick={closeModal}>{t('Button:clear')}</Button>
        <AnchorButton href={getConfig().externalLinks.contact} variant="secondary" target="_blank">
          {t('Common:contactUs')}
        </AnchorButton>
      </ModalActions>
    </Modal>
  );
};

export default WithdrawalIpAddressCheck;
